import _ from 'lodash';
import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export const GlobalSettingsComponent = ({ selectGlobalSettings, handleInnerFormChange }: any) => {

    return (
        <>
            <AccordionContainer
                child={
                    <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        {!selectGlobalSettings?.DMSSettings?.IsStorageAccountEnabled &&
                            <InputContainer
                                label="Storage Account Enabled"
                                name="IsStorageAccountEnabled"
                                onValueChange={(event: any) => {
                                    handleInnerFormChange(
                                        event,
                                        'DMSSettings.IsStorageAccountEnabled',
                                        selectGlobalSettings?.DMSSettings
                                    )
                                }}
                                type="checkbox"
                                value={selectGlobalSettings?.DMSSettings?.IsStorageAccountEnabled}
                            />
                        }
                        {selectGlobalSettings?.DMSSettings?.IsStorageAccountEnabled &&
                            <InputContainer
                                isDisabled
                                label="Storage Account Enabled"
                                name="IsStorageAccountEnabled"
                                onValueChange={(event: any) => {
                                    handleInnerFormChange(
                                        event,
                                        'DMSSettings.IsStorageAccountEnabled',
                                        selectGlobalSettings?.DMSSettings
                                    )
                                }}
                                type="checkbox"
                                value={selectGlobalSettings?.DMSSettings?.IsStorageAccountEnabled}
                            />
                        }
                        {selectGlobalSettings?.DMSSettings?.IsStorageAccountEnabled &&
                            <>
                                <InputContainer
                                    isDisabled
                                    label="CDN Service Enabled"
                                    name="IsCDNServiceEnabled"
                                    onValueChange={(event: any) => {
                                        handleInnerFormChange(
                                            event,
                                            'DMSSettings.IsCDNServiceEnabled',
                                            selectGlobalSettings?.DMSSettings
                                        );
                                    }}
                                    type="checkbox"
                                    value={selectGlobalSettings?.DMSSettings?.IsCDNServiceEnabled} />
                                <InputContainer
                                    label="Enable Newly Added Folders"
                                    name="EnableNewlyAddedFolders"
                                    onValueChange={(event: any) => {
                                        handleInnerFormChange(
                                            event,
                                            'DMSSettings.EnableNewlyAddedFolders',
                                            selectGlobalSettings?.DMSSettings
                                        );
                                    }}
                                    type="checkbox"
                                    value={selectGlobalSettings?.DMSSettings?.EnableNewlyAddedFolders} />
                                <InputContainer
                                    label="Enable Folder For Vendor"
                                    name="EnableFolderForVendor"
                                    onValueChange={(event: any) => {
                                        handleInnerFormChange(
                                            event,
                                            'DMSSettings.EnableFolderForVendor',
                                            selectGlobalSettings?.DMSSettings
                                        );
                                    }}
                                    type="checkbox"
                                    value={selectGlobalSettings?.DMSSettings?.EnableFolderForVendor}
                                />
                            </>
                        }
                    </div>
                }
                expandedPanel="DMS Settings"
                headerTitle="DMS Settings"
            />
            <AccordionContainer
                child={
                    <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <InputContainer
                            label="Email Service Enabled"
                            name="IsEmailServiceEnabled"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'EmailSettings.IsEmailServiceEnabled',
                                    selectGlobalSettings?.EmailSettings
                                )
                            }}
                            type="checkbox"
                            value={selectGlobalSettings?.EmailSettings?.IsEmailServiceEnabled}
                        />
                    </div>
                }
                expandedPanel="Email Settings"
                headerTitle="Email Settings"
            />
            <AccordionContainer
                child={
                    <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <InputContainer
                            label="SMS Service Enabled"
                            name="IsSMSServiceEnabled"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'SMSSettings.IsSMSServiceEnabled',
                                    selectGlobalSettings?.SMSSettings
                                )
                            }}
                            type="checkbox"
                            value={selectGlobalSettings?.SMSSettings?.IsSMSServiceEnabled}
                        />
                    </div>
                }
                expandedPanel="SMS Settings"
                headerTitle="SMS Settings"
            />
            <AccordionContainer
                child={
                    <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <InputContainer
                            label="BarCode Service Enabled"
                            name="IsBarCodeServiceEnabled"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'BarCodeSettings.IsBarCodeServiceEnabled',
                                    selectGlobalSettings?.BarCodeSettings
                                )
                            }}
                            type="checkbox"
                            value={selectGlobalSettings?.BarCodeSettings?.IsBarCodeServiceEnabled}
                        />
                    </div>
                }
                expandedPanel="BarCode Settings"
                headerTitle="BarCode Settings"
            />
            <AccordionContainer
                child={
                    <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <InputContainer
                            label="QRCode Service Enabled"
                            name="IsQRCodeServiceEnabled"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'QRCodeSettings.IsQRCodeServiceEnabled',
                                    selectGlobalSettings?.QRCodeSettings
                                )
                            }}
                            type="checkbox"
                            value={selectGlobalSettings?.QRCodeSettings?.IsQRCodeServiceEnabled}
                        />
                    </div>
                }
                expandedPanel="QRCode Settings"
                headerTitle="QRCode Settings"
            />
            <AccordionContainer
                child={
                    <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <InputContainer
                            label="Notes Enabled"
                            name="IsNotesEnabled"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'NoteSettings.IsNotesEnabled',
                                    selectGlobalSettings?.NoteSettings
                                )
                            }}
                            type="checkbox"
                            value={selectGlobalSettings?.NoteSettings?.IsNotesEnabled}
                        />
                    </div>
                }
                expandedPanel="Note Settings"
                headerTitle="Note Settings"
            />
            <AccordionContainer
                child={
                    <div className='grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <InputContainer
                            label="Enable ZeoValue Transactions"
                            name="EnableZeoValueTransactions"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'GlobalTenantSettings.EnableZeoValueTransactions',
                                    selectGlobalSettings?.GlobalTenantSettings
                                )
                            }}
                            type="checkbox"
                            value={selectGlobalSettings?.GlobalTenantSettings?.EnableZeoValueTransactions}
                        />
                        <InputContainer
                            label="Maintain BillWise Details"
                            name="MaintainBillWiseDetails"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'GlobalTenantSettings.MaintainBillWiseDetails',
                                    selectGlobalSettings?.GlobalTenantSettings
                                )
                            }}
                            type="checkbox"
                            value={selectGlobalSettings?.GlobalTenantSettings?.MaintainBillWiseDetails}
                        />
                        <InputContainer
                            label="Enable GST"
                            name="EnableGST"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'GlobalTenantSettings.EnableGST',
                                    selectGlobalSettings?.GlobalTenantSettings
                                )
                            }}
                            type="checkbox"
                            value={selectGlobalSettings?.GlobalTenantSettings?.EnableGST}
                        />
                        <InputContainer
                            label="Enable Service Tax"
                            name="EnableServiceTax"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'GlobalTenantSettings.EnableServiceTax',
                                    selectGlobalSettings?.GlobalTenantSettings
                                )
                            }}
                            type="checkbox"
                            value={selectGlobalSettings?.GlobalTenantSettings?.EnableServiceTax}
                        />
                        <InputContainer
                            label="Enable Banking Features"
                            name="IsNotesEnabled"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'GlobalTenantSettings.EnableBankingFeatures',
                                    selectGlobalSettings?.GlobalTenantSettings
                                )
                            }}
                            type="checkbox"
                            value={selectGlobalSettings?.GlobalTenantSettings?.EnableBankingFeatures}
                        />
                        <InputContainer
                            label="SETALTER Transaction Types"
                            name="SETALTERTransactionTypes"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'GlobalTenantSettings.SETALTERTransactionTypes',
                                    selectGlobalSettings?.GlobalTenantSettings
                                )
                            }}
                            type="checkbox"
                            value={selectGlobalSettings?.GlobalTenantSettings?.SETALTERTransactionTypes}
                        />
                    </div>
                }
                expandedPanel="Global Tenant Settings"
                headerTitle="Global Tenant Settings"
            />
            <AccordionContainer
                child={
                    <div className='grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <InputContainer
                            label="Enable Gateway Communication Logs"
                            name="EnableGatewayCommunicationLogs"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'GlobalLogSettings.EnableGatewayCommunicationLogs',
                                    selectGlobalSettings?.GlobalLogSettings
                                )
                            }}
                            type="checkbox"
                            value={selectGlobalSettings?.GlobalLogSettings?.EnableGatewayCommunicationLogs}
                        />
                        <InputContainer
                            label="Enable Fluent Validation Logs"
                            name="EnableFluentValidationLogs"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'GlobalLogSettings.EnableFluentValidationLogs',
                                    selectGlobalSettings?.GlobalLogSettings
                                )
                            }}
                            type="checkbox"
                            value={selectGlobalSettings?.GlobalLogSettings?.EnableFluentValidationLogs}
                        />
                        <InputContainer
                            label="Enable Handler Logs"
                            name="EnableHandlerLogs"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'GlobalLogSettings.EnableHandlerLogs',
                                    selectGlobalSettings?.GlobalLogSettings
                                )
                            }}
                            type="checkbox"
                            value={selectGlobalSettings?.GlobalLogSettings?.EnableHandlerLogs}
                        />
                        <InputContainer
                            label="Enable Enterprise Manger Logs"
                            name="EnableEnterpriseMangerLogs"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'GlobalLogSettings.EnableEnterpriseMangerLogs',
                                    selectGlobalSettings?.GlobalLogSettings
                                )
                            }}
                            type="checkbox"
                            value={selectGlobalSettings?.GlobalLogSettings?.EnableEnterpriseMangerLogs}
                        />
                        <InputContainer
                            label="Enable Data Manager Logs"
                            name="EnableDataManagerLogs"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'GlobalLogSettings.EnableDataManagerLogs',
                                    selectGlobalSettings?.GlobalLogSettings
                                )
                            }}
                            type="checkbox"
                            value={selectGlobalSettings?.GlobalLogSettings?.EnableDataManagerLogs}
                        />
                        <InputContainer
                            label="Enable Read Model Logs"
                            name="EnableReadModelLogs "
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'GlobalLogSettings.EnableReadModelLogs',
                                    selectGlobalSettings?.GlobalLogSettings
                                )
                            }}
                            type="checkbox"
                            value={selectGlobalSettings?.GlobalLogSettings?.EnableReadModelLogs}
                        />
                        <InputContainer
                            label="Enable Snap Shot Logs"
                            name="EnableSnapShotLogs"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'GlobalLogSettings.EnableSnapShotLogs',
                                    selectGlobalSettings?.GlobalLogSettings
                                )
                            }}
                            type="checkbox"
                            value={selectGlobalSettings?.GlobalLogSettings?.EnableSnapShotLogs}
                        />
                        <InputContainer
                            label="Enable Publish To Cloud Logs"
                            name="EnablePublishToCloudLogs"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'GlobalLogSettings.EnablePublishToCloudLogs',
                                    selectGlobalSettings?.GlobalLogSettings
                                )
                            }}
                            type="checkbox"
                            value={selectGlobalSettings?.GlobalLogSettings?.EnablePublishToCloudLogs}
                        />
                        <InputContainer
                            label="Enable Catalog Publish Logs"
                            name="EnableCatalogPublishLogs"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'GlobalLogSettings.EnableCatalogPublishLogs',
                                    selectGlobalSettings?.GlobalLogSettings
                                )
                            }}
                            type="checkbox"
                            value={selectGlobalSettings?.GlobalLogSettings?.EnableCatalogPublishLogs}
                        />
                        <InputContainer
                            label="Enable Incremental Sync Logs"
                            name="EnableIncrementalSyncLogs"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'GlobalLogSettings.EnableIncrementalSyncLogs',
                                    selectGlobalSettings?.GlobalLogSettings
                                )
                            }}
                            type="checkbox"
                            value={selectGlobalSettings?.GlobalLogSettings?.EnableIncrementalSyncLogs}
                        />
                    </div>
                }
                expandedPanel="Global Catalog Settings"
                headerTitle="Global Catalog Settings"
            />
        </>
    );
};

export default GlobalSettingsComponent;
